import React, { createContext, useContext, useState, ReactNode } from 'react';

export enum MenuItems {
  Home = "home",
  ShoppingCart = "shopping-cart",
  AboutUs = "o-nas",
  Winners = "winners",
  Auctions = "auctions",
  CurrentAuction = "aktualni-aukce",
  Blog = "blog",
  Help = "napoveda",
  Contact = "kontakt",
  LogOut = "logout",
  LogIn = "login",
}

interface UIContextType {
  selectedMenu: MenuItems;
  setSelectedMenu: (menu: MenuItems) => void;
  isMobileMenuOpen: boolean;
  setIsMobileMenuOpen: (isOpen: boolean) => void;
  toggleMobileMenu: () => void;
}

const UIContext = createContext<UIContextType | undefined>(undefined);

interface UIProviderProps {
  children: ReactNode;
}

export const UIProvider: React.FC<UIProviderProps> = ({ children }) => {
  const [selectedMenu, setSelectedMenuState] = useState<MenuItems>(MenuItems.Home);
  const [isMobileMenuOpen, setIsMobileMenuOpenState] = useState<boolean>(false);

  const setSelectedMenu = (menu: MenuItems) => {
    setSelectedMenuState(menu);
  };

  const setIsMobileMenuOpen = (isOpen: boolean) => {
    setIsMobileMenuOpenState(isOpen);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpenState(prev => !prev);
  };

  return (
    <UIContext.Provider value={{
      selectedMenu,
      setSelectedMenu,
      isMobileMenuOpen,
      setIsMobileMenuOpen,
      toggleMobileMenu
    }}>
      {children}
    </UIContext.Provider>
  );
};

export const useUI = () => {
  const context = useContext(UIContext);
  if (context === undefined) {
    throw new Error('useUI must be used within a UIProvider');
  }
  return context;
};
